import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { investmentPlans } from "../../data";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import ready from "../../assets/ready.jpg";
import { qAndA } from "../../data";
import { domain } from "../../data";
import { GiMiner } from "react-icons/gi";

export default function QAndA() {
	const [expanded, setExpanded] = React.useState(false);

	const handleChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};

	return (
		<div className="  w-[90%]  lg:w-[65%]   lg:my-[2rem] bg-[#1B1B22]   mx-auto   flex   flex-col   lg:flex-row  gap-[1rem]  ">
			<div className="  lg:w-[50%]   w-full flex flex-col text-center  gap-5  justify-center  items-center  p-4  ">
				<motion.h5
					animate={{ opacity: 0 }}
					whileInView={{ opacity: 1 }}
					transition={{ duration: 1.5 }}
					viewport={{ once: true }}
					className="text-[1.5rem]  capitalize text-center  mx-auto font-semibold   tracking-wider p-[0.3rem] ">
					F A Q
				</motion.h5>
				{/* <img src={ready} alt="experts" className="" /> */}
			</div>
			<div className="w-full">
				{qAndA.map((data) => (
					<Accordion
						key={data.id}
						expanded={expanded === `panel${data.id}`}
						onChange={handleChange(`panel${data.id}`)}>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
							aria-controls={`panel${data.id}bh-content`}
							id={`panel${data.id}bh-header`}
							sx={{ bgcolor: "black", color: "white" }}>
							<Typography
								component="span"
								sx={{
									width: "80%",
									flexShrink: 0,
									fontWeight: "bold",
								}}>
								{/* {data.icon} */}
								{data.name}
							</Typography>
							{/* <Typography component="span" sx={{ color: "text.secondary" }}>
							ROI: <span>%{data.ROI}</span>
						</Typography> */}
						</AccordionSummary>
						<AccordionDetails sx={{ bgcolor: "black", color: "white" }}>
							<p className="text-gray-400 text-[0.9rem]  ">{data.desc}</p>
							{/* <ul className="bg-gray-800   text-white  capitalize">
								<li className="  border-t-2  p-[0.5rem]  ">
									<span className="font-serif  mx-[0.5rem]">
										{" "}
										Capital back:
									</span>{" "}
									<span>{data.CB}</span>
								</li>
								<li className="  border-y-2  p-[0.5rem]">
									<span className="font-serif  mx-[0.5rem]">ROI: </span>
									<span>{data.ROI}%</span>
								</li>
								<li className="p-[0.5rem]">
									<span className="font-serif  mx-[0.5rem]">
										Referal commission:
									</span>{" "}
									<span>{data.RC}</span>
								</li>
								<li className="  border-y-2  p-[0.5rem]">
									<span className="font-serif  mx-[0.5rem]">
										{" "}
										Minimum amount:{" "}
									</span>
									<span>${data.minAmount}</span>
								</li>

								<li className="  border-b-2  p-[0.5rem]">
									<span className="font-serif  mx-[0.5rem]">
										Maximum amount:
									</span>{" "}
									<span>${data.maxAmount}</span>
								</li>
								<li className="bg-black">
									<Link
										className="bg-red-600 inline-block text-white   rounded-full my-[1rem]    p-[0.6rem] font-medium  ml-[0.8rem]     text-[1.1rem]   font-serif    py-[0.2rem]"
										to="/en/register">
										Choose Plan &#8599;
									</Link>
								</li>
							</ul> */}
						</AccordionDetails>
					</Accordion>
				))}
			</div>
		</div>
	);
}
